function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelativityService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.806 5.806h24.387v24.387H17.806z",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f8981d",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.806 17.806h24.387v24.387H5.806z",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#f8981d",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelativityService);
export default __webpack_public_path__ + "static/media/relativityService.56aa044039547c04fe1a1222b467cbb1.svg";
export { ForwardRef as ReactComponent };